import { render, staticRenderFns } from "./BackgroundVideo.vue?vue&type=template&id=71741346&scoped=true&"
import script from "./BackgroundVideo.vue?vue&type=script&lang=ts&"
export * from "./BackgroundVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BackgroundVideo.vue?vue&type=style&index=0&id=71741346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71741346",
  null
  
)

export default component.exports